export default {
	INICIO: 'Inicio',
	COMUM: {
		PAGINA_NAO_AUTORIZADO: 'PaginaNaoAutorizado',
		PAGINA_NAO_ENCONTRADA: 'PaginaNaoEncontrada',
		REDIRECIONAR_EDITAR_USUARIO: 'RedirecionarEditarUsuario',
	},
	PROCESSO_UTILIZACAO: {
		PROCESSO_UTILIZACAO_VIEW: 'ProcessoUtilizacaoView',
		BUSCAR_POR_FILTRO: 'BuscarPorFiltro',
	},
	ATA: {
		REGISTRO_PRECO_VIEW: 'RegistroPrecoView',
		ATA_VIEW: 'AtaView',
		ATA_ACESSAR_VIEW: 'AtaAcessarView',
		ATA_ACESSAR_FISCAIS_VIEW: 'ataAcessarFiscaisView',
		ATA_ACESSAR_PENALIDADES_VIEW: 'ataAcessarPenalidadesView',
		ATA_ACESSAR_GESTAO_ATA_VIEW: 'AtaAcessarGestaoAtaView',
		ATA_ACESSAR_GESTAO_PEDIDO_VIEW: 'AtaAcessarGestaoPedidoView',
		ATA_ACESSAR_GESTAO_PEDIDO_CONCLUIDOS_VIEW: 'AtaAcessarGestaoPedidoConcluidosView',
		ATA_ACESSAR_GESTAO_PEDIDO_EM_ANDAMENTO_VIEW: 'AtaAcessarGestaoPedidoEmAndamentoView',
		ATA_ACESSAR_ITENS_VIEW: 'AtaAcessarItensView',
		ATA_ACESSAR_INFORMACOES_VIEW: 'AtaAcessarInformacoesView',
		ATA_ACESSAR_DOCUMENTOS_VIEW: 'AtaAcessarDocumentosView',
		ATA_ACESSAR_ACOMPANHAMENTO_VIEW: 'AtaAcessarAcompanhamentoView',
		ATA_ACESSAR_CONTROLE_SALDO_ORGAO_VIEW: 'AtaAcessarControleSaldoOrgaoView',
		ATA_ACESSAR_PARTES_ENVOLVIDAS_VIEW: 'AtaAcessarPartesEnvolvidasView',
		ATA_ACESSAR_ADESOES_VIEW: 'AtaAcessarAdesoesView',
		ATA_ACESSAR_MINHAS_ADESOES_VIEW: 'AtaAcessarMinhasAdesoesView',
		ATA_ACESSAR_ADITIVO_APOSTILA_VIEW: 'AtaAcessarAditivoApostilaView',
		PROCESSO_DIGITAL: {
			DESENTRANHAMENTO: {
				DESENTRANHAR_DOCUMENTO_PROCESSO_DIGITAL_VIEW: 'DesentranharDocumentoProcessoDigitalView',
				PROCESSO_REDIGIR_TERMO_DESENTRANHAMENTO: 'ProcessoRedigirTermoDesentranhamento',
				PROCESSO_ASSINAR_TERMO_DESENTRANHAMENTO: 'ProcessoAssinarTermoDesentranhamento',
				PROCESSO_JUNTAR_TERMO_DESENTRANHAMENTO: 'ProcessoJuntarTermoDesentranhamento',
			},
		},
	},
	PEDIDO: {
		PEDIDO_ABA_VIEW: 'PedidoAbaView',
		NOVO_VIEW: 'PedidoNovoView',
		ACESSAR_VIEW: 'PedidoAcessarView',
		ACESSAR_ITENS_VIEW: 'PedidoAcessarItensView',
		ACESSAR_DOCUMENTOS_VIEW: 'PedidoAcessarDocumentosView',
		ACESSAR_LINHA_DO_TEMPO_VIEW: 'PedidoAcessarLinhaDoTempoView',
		ACESSAR_OCORRENCIAS_VIEW: 'PedidoAcessarOcorrenciasView',
		ACESSAR_PENALIDADES_VIEW: 'PedidoAcessarPenalidadesView',
		PROCESSO_DIGITAL: {
			DESENTRANHAMENTO: {
				DESENTRANHAR_DOCUMENTO_PROCESSO_DIGITAL_VIEW: 'pedidoDesentranharDocumentoProcessoDigitalView',
				PROCESSO_REDIGIR_TERMO_DESENTRANHAMENTO: 'pedidoProcessoRedigirTermoDesentranhamento',
				PROCESSO_ASSINAR_TERMO_DESENTRANHAMENTO: 'pedidoProcessoAssinarTermoDesentranhamento',
				PROCESSO_JUNTAR_TERMO_DESENTRANHAMENTO: 'pedidoProcessoJuntarTermoDesentranhamento',
			},
		},
	},
	ADESAO: {
		ADESAO_VIEW: 'AdesaoView',
		ACESSAR_LINHA_DO_TEMPO_VIEW: 'AdesaoAcessarLinhaDoTempoView',
		ACESSAR_OCORRENCIAS_VIEW: 'AdesaoAcessarOcorrenciasView',
		ADERENTE: {
			ADESAO_VIEW: 'AdesaoAderenteView',
			ADESAO_ITENS: 'AdesaoAderenteItens',
			ADESAO_DOCUMENTOS: 'AdesaoAderenteDocumentos',
		},
		GESTOR: {
			ADESAO_VIEW: 'AdesaoGestorView',
			ADESAO_ITENS: 'AdesaoGestorItens',
			ADESAO_DOCUMENTOS: 'AdesaoGestorDocumentos',
		},
		PROCESSO_DIGITAL: {
			DESENTRANHAMENTO: {
				DESENTRANHAR_DOCUMENTO_PROCESSO_DIGITAL_VIEW: 'AdesaoDesentranharDocumentoProcessoDigitalView',
				PROCESSO_REDIGIR_TERMO_DESENTRANHAMENTO: 'AdesaoProcessoRedigirTermoDesentranhamento',
				PROCESSO_ASSINAR_TERMO_DESENTRANHAMENTO: 'AdesaoProcessoAssinarTermoDesentranhamento',
				PROCESSO_JUNTAR_TERMO_DESENTRANHAMENTO: 'AdesaoProcessoJuntarTermoDesentranhamento',
			},
		},
	},
	CONFIGURACAO: {
		CONFIGURACAO_VIEW: 'ConfiguracaoView',
		MODELO_DOCUMENTO_VIEW: 'ModeloDocumentoView',
		FISCAIS_VIEW: 'FiscaisView',
		REVISOES: {
			REVISOES_VIEW: 'RevisoesView',
			REVISOES_CRIACAO_VIEW: 'RevisoesCriacaoView',
			REVISOES_EDICAO_VIEW: 'RevisoesEdicaoView',
			REVISOES_VISUALIZACAO_VIEW: 'RevisoesVisualizacaoView',
		},
	},
	RELATORIO: {
		RELATORIO_VIEW: 'RelatorioView',
		PERSONALIZADO: 'RelatorioPersonalizadoView',
		CONTROLE_ADESOES_VIEW: 'RelatorioControleAdesoesView',
		CONTROLE_SALDOS_VIEW: 'RelatorioControleSaldosView',
		PAINEL_LISTAGEM: 'RelatorioPainelListagemView',
		PAINEL_VISUALIZACAO: 'RelatorioPainelVisualizacaoView',
	},
	ADITIVO_APOSTILA: {
		PROCESSO_DIGITAL: {
			DESENTRANHAMENTO: {
				DESENTRANHAR_DOCUMENTO_PROCESSO_DIGITAL_VIEW: 'AditivoApostilaDesentranharDocumentoProcessoDigitalView',
				PROCESSO_REDIGIR_TERMO_DESENTRANHAMENTO: 'AditivoApostilaProcessoRedigirTermoDesentranhamento',
				PROCESSO_ASSINAR_TERMO_DESENTRANHAMENTO: 'AditivoApostilaProcessoAssinarTermoDesentranhamento',
				PROCESSO_JUNTAR_TERMO_DESENTRANHAMENTO: 'AditivoApostilaProcessoJuntarTermoDesentranhamento',
			},
		},
	},
	SOBRE: {
		SOBRE_VIEW: 'SobreView',
		MANUAL_VIEW: 'ManualView',
	},
}
